import { createMiddleware } from "@tanstack/react-start"

/**
 * Authentication middleware for server functions
 * Uses dynamic import for assertUser to prevent server-only code leaking into client bundle
 * Passes authenticated user in context for handlers to use
 */
export const authFunctionMiddleware = createMiddleware().server(async ({ next, request }) => {
  const { assertUser, getUserFromRequest } = await import("./auth")
  await assertUser(request)

  // Get user and pass to handler context
  const user = await getUserFromRequest(request)

  return next({ context: { user } })
})
